export const T = {
  hr: {
    nav: { home:"Početna", services:"Usluge", about:"O nama", contact:"Kontakt" },
    home:{
      hero_title:"Vaš partner za europska tržišta",
      hero_sub:"Brand Ambassador d.o.o. zastupa vrhunske prehrambene brendove u maloprodajnim lancima diljem Europe – od pregovaranja do isporuke.",
      cta_primary:"Naše usluge", cta_secondary:"Kontaktirajte nas",
      stats:[
        { value:"10+", label:"godina iskustva" },
        { value:"7+",   label:"europskih tržišta" },
        { value:"15+", label:"maloprodajnih partnera" },
      ],
      why_title:"Zašto Brand Ambassador?",
      why:[
        { icon:"bi-shield-check",  title:"Povjerenje",    desc:"Dugogodišnji odnosi s vodećim europskim lancima." },
        { icon:"bi-graph-up-arrow",title:"Rast",          desc:"Kontinuirano povećanje prometa za sve klijente." },
        { icon:"bi-translate",     title:"Višejezičnost", desc:"Tim koji komunicira na HR, DE, EN." },
        { icon:"bi-clipboard-data",title:"Transparentnost","desc":"Detaljno praćenje narudžbi i prihoda u realnom vremenu." },
      ],
    },
    services:{
      title:"Naše usluge",
      sub:"Nudimo cjelovitu uslugu zastupanja – od prvog kontakta s kupcem do praćenja isporuke i naplate.",
      items:[
        { icon:"bi-geo-alt-fill",    title:"Tržišna ekspanzija",   desc:"Otvaramo nova tržišta u DE, CZ, SK, PL, RO, HR i BG za vaše proizvode. Poznajemo lokalne propise, uvjete listing-a i zahtjeve pojedinih lanaca." },
        { icon:"bi-search",          title:"Analiza tržišta",      desc:"Dubinska istraživanja konkurentskog okruženja, cjenovnih trendova i potenciJa!a pojedinih kategorija. Donosimo preporuke temeljene na stvarnim podacima." },
        { icon:"bi-lightbulb-fill",  title:"Strateški savjeti",    desc:"Prilagođene go-to-market strategije, pozicioniranje brenda i planiranje asortimana za svako ciljno tržište i kanal prodaje." },
        { icon:"bi-bar-chart-fill",  title:"Praćenje prometa",     desc:"Detaljna analitika narudžbi i prihoda po partnerima, ugovornim razdobljima i artiklima. Admin dashboard s realnim podacima dostupan 24/7." },
        { icon:"bi-person-plus-fill",title:"Razvoj mreže",         desc:"Izgradnja i održavanje dugoročnih odnosa s kupcima u maloprodajnim lancima – Kaufland, Norma, Edeka, Lidl, Rewe, Penny i drugi." },
        { icon:"bi-truck",           title:"Logistika i tender",   desc:"Koordinacija tendera, pregovaranje uvjeta, praćenje isporuka i rješavanje reklamacija zajedno s klijentima i lancima." },
      ],
      partners_title:"Maloprodajni partneri",
      partners_sub:"Aktivno surađujemo s vodećim europskim lancima:",
    },
    about:{
      title:"O nama",
      sub:"Više od desetljeća iskustva u zastupanju prehrambenih brendova na europskim tržištima.",
      story_title:"Naša priča",
      story:`Brand Ambassador d.o.o. osnovan je s jednim ciljem: biti premosnica između kvalitetnih proizvođača hrane i europske maloprodaje.

Kao iskusni zastupnici, razumijemo obje strane – znamo što maloprodajni lanci traže i što proizvođačima treba kako bi uspjeli izvan domicilnog tržišta.

Naš tim svakodnevno prati narudžbe, komunicira s kupcima, pregovara uvjete i osigurava da svaki artikl pravovremeno dođe na policu – od Berlina do Bukarešta.`,
      values_title:"Naše vrijednosti",
      values:[
        { icon:"bi-handshake",     title:"Partnerstvo",     desc:"Gradimo dugoročne odnose temeljene na povjerenju i transparentnosti." },
        { icon:"bi-star-fill",     title:"Kvaliteta",       desc:"Zastupamo samo brendove u koje vjerujemo i koji donose vrijednost potrošačima." },
        { icon:"bi-lightning-fill",title:"Agilnost",        desc:"Brzo reagiramo na promjene tržišta i potrebe klijenata." },
        { icon:"bi-globe2",        title:"Europska mreža",  desc:"Pokrivamo 7+ tržišta s lokalnim znanjem i kontaktima." },
      ],
      producers_title:"Partneri – proizvođači",
      retailers_title:"Partneri – maloprodajni lanci",
      visit:"Posjeti web",
    },
    contact:{
      title:"Kontakt",
      sub:"Rado ćemo odgovoriti na vaša pitanja ili dogovoriti sastanak.",
      info_title:"Podaci za kontakt",
      info:`Brand Ambassador d.o.o.
Augsburg, Germany
office@brand-ambassador.net
+49 174 3576054`,
      working_hours:"Radno vrijeme: pon – pet, 08:00 – 20:00",
      form_title:"Pošaljite nam poruku",
      nameLbl:"Ime i prezime", emailLbl:"E-mail", companyLbl:"Tvrtka", msgLbl:"Poruka",
      pName:"Vaše ime i prezime", pEmail:"vasa@email.com", pCompany:"Naziv tvrtke", pMsg:"Opišite kako vam možemo pomoći...",
      send:"Pošalji poruku", success:"Hvala! Javit ćemo vam se u roku 24 sata.", error:"Greška pri slanju. Molimo pokušajte ponovo ili nas kontaktirajte direktno.",
    },
    footer:{ rights:"© 2025 Brand Ambassador d.o.o. Sva prava pridržana." },
    dash:{ welcome:"Admin dashboard", logout:"Odjava", clients:"Klijenti", comingSoon:"Podaci uskoro dostupni", back:"← Povratak na stranicu" },
    login:{ title:"Admin prijava", user:"Korisničko ime", pass:"Lozinka", btn:"Prijava", error:"Neispravno korisničko ime ili lozinka.", hint:"Pristup samo za ovlaštene administratore." },
    prices:"Ugovorene cijene",
  },
  en: {
    nav:{ home:"Home", services:"Services", about:"About", contact:"Contact" },
    home:{
      hero_title:"Your partner for European markets",
      hero_sub:"Brand Ambassador Ltd. represents premium food brands in retail chains across Europe – from negotiations to delivery.",
      cta_primary:"Our services", cta_secondary:"Contact us",
      stats:[
        { value:"10+", label:"years of experience" },
        { value:"7+",   label:"European markets" },
        { value:"15+", label:"retail partners" },
      ],
      why_title:"Why Brand Ambassador?",
      why:[
        { icon:"bi-shield-check",  title:"Trust",           desc:"Long-standing relationships with leading European chains." },
        { icon:"bi-graph-up-arrow",title:"Growth",          desc:"Continuous revenue growth for all clients." },
        { icon:"bi-translate",     title:"Multilingual",    desc:"Team communicating in HR, DE, EN." },
        { icon:"bi-clipboard-data",title:"Transparency",    desc:"Detailed order and revenue tracking in real time." },
      ],
    },
    services:{
      title:"Our Services",
      sub:"We offer end-to-end brand representation – from first buyer contact to delivery tracking and invoicing.",
      items:[
        { icon:"bi-geo-alt-fill",    title:"Market Expansion",    desc:"Opening new markets in DE, CZ, SK, PL, RO, HR and BG for your products. We know local regulations, listing conditions and chain requirements." },
        { icon:"bi-search",          title:"Market Analysis",     desc:"In-depth competitive analysis, pricing trends and category potential. Data-driven recommendations for each market." },
        { icon:"bi-lightbulb-fill",  title:"Strategic Consulting",desc:"Tailored go-to-market strategies, brand positioning and assortment planning for each target market and sales channel." },
        { icon:"bi-bar-chart-fill",  title:"Revenue Tracking",    desc:"Detailed order and revenue analytics per partner, contract period and SKU. Admin dashboard available 24/7." },
        { icon:"bi-person-plus-fill",title:"Network Development", desc:"Building long-term buyer relationships in retail chains – Kaufland, Norma, Edeka, Lidl, Rewe, Penny and others." },
        { icon:"bi-truck",           title:"Logistics & Tender",  desc:"Tender coordination, terms negotiation, delivery tracking and claim resolution together with clients and chains." },
      ],
      partners_title:"Retail Partners",
      partners_sub:"We actively work with leading European chains:",
    },
    about:{
      title:"About Us",
      sub:"Over a decade of experience representing food brands across European markets.",
      story_title:"Our Story",
      story:`Brand Ambassador Ltd. was founded with one goal: to bridge the gap between quality food producers and European retail.

As experienced representatives, we understand both sides – we know what retail chains require and what producers need to succeed outside their home market.

Our team monitors orders daily, communicates with buyers, negotiates terms and ensures every SKU reaches the shelf on time – from Berlin to Bucharest.`,
      values_title:"Our Values",
      values:[
        { icon:"bi-handshake",     title:"Partnership",   desc:"We build long-term relationships based on trust and transparency." },
        { icon:"bi-star-fill",     title:"Quality",       desc:"We represent only brands we believe in and that bring value to consumers." },
        { icon:"bi-lightning-fill",title:"Agility",       desc:"We respond quickly to market changes and client needs." },
        { icon:"bi-globe2",        title:"European Network",desc:"Covering 7+ markets with local knowledge and contacts." },
      ],
      producers_title:"Partners – Producers",
      retailers_title:"Partners – Retail Chains",
      visit:"Visit website",
    },
    contact:{
      title:"Contact",
      sub:"We'd be happy to answer your questions or arrange a meeting.",
      info_title:"Contact details",
      info:`Brand Ambassador d.o.o.
Augsburg, Germany
office@brand-ambassador.net
+49 174 3576054`,
      working_hours:"Working hours: Mon – Fri, 08:00 – 20:00",
      form_title:"Send us a message",
      nameLbl:"Full name", emailLbl:"Email", companyLbl:"Company", msgLbl:"Message",
      pName:"Your full name", pEmail:"your@email.com", pCompany:"Company name", pMsg:"Describe how we can help you...",
      send:"Send message", success:"Thank you! We'll get back to you within 24 hours.", error:"Sending failed. Please try again or contact us directly.",
    },
    footer:{ rights:"© 2025 Brand Ambassador d.o.o. All rights reserved." },
    dash:{ welcome:"Admin dashboard", logout:"Log out", clients:"Clients", comingSoon:"Data coming soon", back:"← Back to website" },
    login:{ title:"Admin login", user:"Username", pass:"Password", btn:"Login", error:"Invalid username or password.", hint:"Access for authorised administrators only." },
  },
  de: {
    nav:{ home:"Startseite", services:"Leistungen", about:"Über uns", contact:"Kontakt" },
    home:{
      hero_title:"Ihr Partner für europäische Märkte",
      hero_sub:"Brand Ambassador GmbH vertritt erstklassige Lebensmittelmarken im europäischen Einzelhandel – von der Verhandlung bis zur Lieferung.",
      cta_primary:"Unsere Leistungen", cta_secondary:"Kontakt aufnehmen",
      stats:[
        { value:"10+", label:"Jahre Erfahrung" },
        { value:"7+",   label:"europäische Märkte" },
        { value:"15+", label:"Einzelhandelspartner" },
      ],
      why_title:"Warum Brand Ambassador?",
      why:[
        { icon:"bi-shield-check",  title:"Vertrauen",      desc:"Langjährige Beziehungen zu führenden europäischen Ketten." },
        { icon:"bi-graph-up-arrow",title:"Wachstum",       desc:"Kontinuierliches Umsatzwachstum für alle Kunden." },
        { icon:"bi-translate",     title:"Mehrsprachig",   desc:"Team kommuniziert auf HR, DE, EN." },
        { icon:"bi-clipboard-data",title:"Transparenz",    desc:"Detailliertes Auftrags- und Umsatz-Tracking in Echtzeit." },
      ],
    },
    services:{
      title:"Unsere Leistungen",
      sub:"Wir bieten vollständige Markenvertretung – vom ersten Käuferkontakt bis zur Lieferverfolgung.",
      items:[
        { icon:"bi-geo-alt-fill",    title:"Marktexpansion",      desc:"Neue Märkte in DE, CZ, SK, PL, RO, HR und BG erschließen. Wir kennen lokale Vorschriften, Listingbedingungen und Kettenanforderungen." },
        { icon:"bi-search",          title:"Marktanalyse",        desc:"Tiefgehende Wettbewerbsanalysen, Preistrends und Kategoriepotenziale. Datenbasierte Empfehlungen für jeden Markt." },
        { icon:"bi-lightbulb-fill",  title:"Strategieberatung",   desc:"Maßgeschneiderte Go-to-Market-Strategien, Markenpositionierung und Sortimentsplanung." },
        { icon:"bi-bar-chart-fill",  title:"Umsatzverfolgung",    desc:"Detaillierte Auftrags- und Umsatzanalyse pro Partner, Vertragszeitraum und Artikel. Admin-Dashboard rund um die Uhr." },
        { icon:"bi-person-plus-fill",title:"Netzwerkausbau",      desc:"Aufbau langfristiger Käuferbeziehungen bei Kaufland, Norma, Edeka, Lidl, Rewe, Penny und anderen." },
        { icon:"bi-truck",           title:"Logistik & Tender",   desc:"Ausschreibungskoordination, Verhandlung, Lieferverfolgung und Reklamationsbearbeitung." },
      ],
      partners_title:"Einzelhandelspartner",
      partners_sub:"Wir arbeiten aktiv mit führenden europäischen Ketten zusammen:",
    },
    about:{
      title:"Über uns",
      sub:"Über ein Jahrzehnt Erfahrung in der Vertretung von Lebensmittelmarken auf europäischen Märkten.",
      story_title:"Unsere Geschichte",
      story:`Brand Ambassador GmbH wurde mit einem Ziel gegründet: eine Brücke zwischen Qualitätsherstellern und dem europäischen Einzelhandel zu bauen.

Als erfahrene Vertreter verstehen wir beide Seiten – wir wissen, was Einzelhandelsketten verlangen und was Hersteller benötigen, um außerhalb ihrer Heimatmärkte erfolgreich zu sein.

Unser Team überwacht täglich Bestellungen, kommuniziert mit Käufern, verhandelt Konditionen und stellt sicher, dass jeder Artikel pünktlich ins Regal kommt – von Berlin bis Bukarest.`,
      values_title:"Unsere Werte",
      values:[
        { icon:"bi-handshake",     title:"Partnerschaft",  desc:"Wir bauen langfristige Beziehungen auf Basis von Vertrauen und Transparenz." },
        { icon:"bi-star-fill",     title:"Qualität",       desc:"Wir vertreten nur Marken, hinter denen wir stehen." },
        { icon:"bi-lightning-fill",title:"Agilität",       desc:"Wir reagieren schnell auf Marktveränderungen." },
        { icon:"bi-globe2",        title:"Europäisches Netzwerk",desc:"7+ Märkte mit lokalem Wissen und Kontakten." },
      ],
      producers_title:"Partner – Hersteller",
      retailers_title:"Partner – Einzelhandelsketten",
      visit:"Webseite besuchen",
    },
    contact:{
      title:"Kontakt",
      sub:"Wir beantworten Ihre Fragen gerne oder vereinbaren einen Termin.",
      info_title:"Kontaktdaten",
      info:`Brand Ambassador d.o.o.
Augsburg, Deutschland
office@brand-ambassador.net
+49 174 3576054`,
      working_hours:"Öffnungszeiten: Mo – Fr, 08:00 – 20:00",
      form_title:"Schreiben Sie uns",
      nameLbl:"Vor- und Nachname", emailLbl:"E-Mail", companyLbl:"Unternehmen", msgLbl:"Nachricht",
      pName:"Ihr Name", pEmail:"ihre@email.de", pCompany:"Unternehmensname", pMsg:"Wie können wir Ihnen helfen?",
      send:"Nachricht senden", success:"Danke! Wir melden uns innerhalb von 24 Stunden.", error:"Fehler beim Senden. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.",
    },
    footer:{ rights:"© 2025 Brand Ambassador d.o.o. Alle Rechte vorbehalten." },
    dash:{ welcome:"Admin-Dashboard", logout:"Abmelden", clients:"Kunden", comingSoon:"Daten demnächst verfügbar", back:"← Zurück zur Website" },
    login:{ title:"Admin-Anmeldung", user:"Benutzername", pass:"Passwort", btn:"Anmelden", error:"Ungültiger Benutzername oder Passwort.", hint:"Zugang nur für autorisierte Administratoren." },
  },
};

// ══════════════════════════════════════════════════════
//  CONTEXT
// ══════════════════════════════════════════════════════
